module.exports = __webpack_public_path__ + "img/TRACTOR_LHD.3e027106.jpg";